import { render, staticRenderFns } from "./kpsrCausePop.vue?vue&type=template&id=66bb5a45"
import script from "./kpsrCausePop.vue?vue&type=script&lang=js"
export * from "./kpsrCausePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66bb5a45')) {
      api.createRecord('66bb5a45', component.options)
    } else {
      api.reload('66bb5a45', component.options)
    }
    module.hot.accept("./kpsrCausePop.vue?vue&type=template&id=66bb5a45", function () {
      api.rerender('66bb5a45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/kpsrCausePop.vue"
export default component.exports